import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["PostHogIdentity"] */ "/app/src/components/analytics/PostHogIdentity.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PostHogProvider"] */ "/app/src/components/analytics/PostHogProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/app/src/components/auth-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ErrorBoundary.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/session-loading-gate.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/app/src/components/theme-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ToastProvider"] */ "/app/src/components/ui/use-toast.tsx");
